import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';
import ShopaholicCartPosition from '@lovata/shopaholic-cart/shopaholic-cart-position';
import ShopaholicCartShippingType from '@lovata/shopaholic-cart/shopaholic-cart-shipping-type';
import ShopaholicCart from '@lovata/shopaholic-cart/shopaholic-cart';
import ProductCardHelper from '../../common/helper/product-card-helper';
import RemoveCardHelper from '../../common/helper/remove-card-helper';

export default new class ProductInfo {
  constructor() {
    this.obShopaholicCartAdd = new ShopaholicCartAdd();
    this.obShopaholicCartRemove = new RemoveCardHelper();
    this.productCardHelper = new ProductCardHelper();

    this.addCartBtnSelector = '_shopaholic-cart-info-add';

    this.preLoaderSelector = 'product-info__preloader';
    this.sMiniCartWrapper = '_shopaholic-cart-mini-wrapper';

    this.productCartPriceWrapper = 'product-info-price__wrap';
    this.productFormWrapper = 'product-info__form';
    this.productFormPreloader = 'product-info__form__preloader';
    this.offerSelectClass = 'product-info-offer__checkbox';
    this.productDataIDSelector = 'data-product-id';
    this.offerDataIDSelector = 'data-offer-id';

    this.obAjaxRequestCallback = null;

    this.sAddComponentMethod = 'Cart::onAdd';
    this.sUpdateComponentMethod = 'Cart::onUpdate';

    ShopaholicCart.instance();

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initCartForm();
    });
    this.initAddCart();
    this.initOfferSelect();
    this.initRemoveOffer();
    this.updateQuantity();
  }

  initCartForm() {
    const arProductsCard = document.querySelectorAll(`.${this.productFormWrapper}`);
    arProductsCard.forEach((el) => {
      const productId = el.getAttribute(this.productDataIDSelector);
      if (!productId) {
        return;
      }
      const offerId = el.getAttribute(this.offerDataIDSelector);
      if (!offerId) {
        return;
      }
      $.request('onAjax', {
        data: {
          product_id: productId,
          offer_id: offerId,
        },
        loading: `.${this.productFormPreloader}`,
        update: {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          'product/product-info/product-info-form': `.${this.productFormWrapper}`,
        },
      });
    });
  }

  initOfferSelect() {
    $('body')
      .on('click', `.${this.offerSelectClass}`, ({ target }) => {
        const productId = target.getAttribute(this.productDataIDSelector);
        const offerId = target.value;

        if (!productId) {
          return;
        }

        if (!offerId) {
          return;
        }

        $.request('onAjax', {
          data: {
            product_id: productId,
            offer_id: offerId,
          },
          loading: `.${this.preLoaderSelector}`,
          update: {
            'product/product-info/product-info-price': `.${this.productCartPriceWrapper}`,
            'product/product-info/product-info-form': `.${this.productFormWrapper}`,
          },
        });
      });
  }

  initAddCart() {
    $('body')
      .on('click', `.${this.addCartBtnSelector}`, (obEvent) => {
        obEvent.preventDefault();

        const { currentTarget: obButton } = obEvent;
        if (obButton.hasAttribute('disabled')) {
          return;
        }

        this.sendAjaxRequest(obButton);
      });
  }

  sendAjaxRequest(obButton, bForceAddMethod = false) {
    if (!obButton) {
      throw new Error('Button node is empty.');
    }

    const productId = obButton.getAttribute(this.productDataIDSelector);
    const offerId = obButton.getAttribute(this.offerDataIDSelector);

    obButton.setAttribute('disabled', 'disabled');
    const obCartPosition = new ShopaholicCartPosition(obButton);
    const obPositionData = obCartPosition.getData();
    const iOfferID = obPositionData.offer_id;
    const obShippingType = new ShopaholicCartShippingType();
    const obOfferProperty = obPositionData.property;
    const iCartQuantity = ShopaholicCart.instance().getOfferQuantity(iOfferID, obOfferProperty);

    obPositionData.quantity += iCartQuantity;

    let obRequestData = {
      data: {
        cart: [obPositionData],
        shipping_type_id: obShippingType.getShippingTypeID(),
      },
      loading: `${this.preLoaderSelector}`,
      update: { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}` },
      complete: ({ responseJSON }) => {
        this.completeCallback(responseJSON, obButton);
        this.updateProductCardModalBtnWrapper(productId, offerId);
      },
    };

    if (this.obAjaxRequestCallback !== null) {
      obRequestData = this.obAjaxRequestCallback(obRequestData, obButton);
    }

    // eslint-disable-next-line max-len
    const ajaxHandler = iCartQuantity >= 1 && !bForceAddMethod ? this.sUpdateComponentMethod : this.sAddComponentMethod;

    $.request(ajaxHandler, obRequestData);
  }

  // eslint-disable-next-line class-methods-use-this
  completeCallback(obResponse, obButton) {
    const { data: obCartData } = obResponse;

    ShopaholicCart.instance().updateCartData(obCartData);

    if (obButton) {
      obButton.removeAttribute('disabled');
    }
  }

  updateProductCardModalBtnWrapper(productId, offerId) {
    $.request('onAjax', {
      data: {
        product_id: productId,
        offer_id: offerId,
      },
      loading: `${this.preLoaderSelector}`,
      update: {
        'product/product-info/product-info-form': `.${this.productFormWrapper}`,
      },
      complete: () => {
      },
    });
  }

  initRemoveOffer() {
    this.obShopaholicCartRemove.setAjaxRequestCallback((obRequestData, obButton) => {
      const productId = obButton.getAttribute(this.productDataIDSelector);
      const offerId = obButton.getAttribute(this.offerDataIDSelector);
      const obCartPosition = new ShopaholicCartPosition(obButton);
      const iPositionID = obCartPosition.getPositionID();
      /* eslint-disable  no-param-reassign */
      obRequestData.data = {
        product_id: productId,
        offer_id: offerId,
        cart: [iPositionID],
        type: 'position',
      };
      obRequestData.loading = `${this.preLoaderSelector}`;
      obRequestData.update = { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sMiniCartWrapper}` };
      obRequestData.update['product/product-info/product-info-form'] = `.${this.productFormWrapper}`;
      /* eslint-enable */
      return obRequestData;
    }).setRemoveSelector('_product-cart-info-remove').init();
  }

  updateQuantity() {
    this.productCardHelper.initUpdateQuantity();
    this.productCardHelper.setRemoveSelector('_product-cart-info-remove').setQuantitySelector('_quantity-info').init();
  }
}();
